import { render, staticRenderFns } from "./zklist.vue?vue&type=template&id=d227423c&scoped=true&"
import script from "./zklist.vue?vue&type=script&lang=js&"
export * from "./zklist.vue?vue&type=script&lang=js&"
import style0 from "./zklist.vue?vue&type=style&index=0&id=d227423c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d227423c",
  null
  
)

export default component.exports